<template>
	<div class="welcome" :class="{ 'ac-bg-black': ac }">
		<header-component :is-soon="true" :progression="false" img-left="/trocachip/img/default_white.png"
			img-right="/trocachip/img/access-white.svg" v-if="!logoMobile" />
		<header-component :is-soon="true" :progression="false" img-left="/trocachip/img/logo.png"
			img-right="/trocachip/img/access-white.svg" v-if="logoMobile" />
		<div class="welcome_background">
			<img src="../assets/images/bg_mobile.png" v-if="!ac" />
			<img src="../assets/images/bg_mobile-AC.png" v-if="ac" />
		</div>
		<div class="container" id="welcome_container">
			<h2 class="welcome_title" v-html="title" />
			<div class="welcome_description">
				<p v-text="description" />
			</div>
			<div class="welcome_card" :class="{ 'ac-bg-gray': ac }">
				<h4 v-if="!isExOi" :class="{ 'ac-color-yellow': ac }" v-text="titleProgress" />
				<strong v-if="isExOi" :class="{ 'ac-color-yellow': ac }" v-html="titleProgress" />
				<ul class="welcome_list">
					<li v-for="(step, key) in steps" :key="key">
						<div>
							<div class="welcome_number_circle"
								:class="{ 'ac-color-yellow': ac, 'ac-border-yellow': ac }" v-text="key + 1" />
							<span class="welcome_action" :class="{ 'ac-color-yellow': ac }" v-text="step.title" />
							<p class="welcome_list_description" :class="{ 'ac-color-white': ac }"
								v-text="step.description" />
							<div class="request_chip-button">
								<button id="trocarchip" class="button_request" :class="{
									'ac-color-black': ac,
									'ac-border-yellow': ac,
									'ac-bg-yellow': ac,
									primary_button_request: key == 0,
								}" @click="handleClick(key)">
									{{ step.text }}
								</button>
							</div>
							<p class="welcome_list_link" :class="{ 'ac-color-white': ac }" v-text="step.link"
								@click="sendTrackerButtonDetails()" />
						</div>
					</li>
				</ul>
			</div>
		</div>
		<modal-change-chip v-if="infoModal" @close="infoModal = false" />

		<alert description="Ops! Um erro inesperado aconteceu" danger="true"
			message="Por favor, tente novamente mais tarde." v-on:close="alertError = !alertError" v-if="alertError" />
	</div>
</template>

<script>
import * as Cookies from 'tiny-cookie';
import { mapState } from 'vuex';
import Auth from '@/core/auth';
import HeaderComponent from '@/components/HeaderComponent';
import trackEvent from '@/services/trackEvent';
import Init from '@/services/init';
import Config from '@/services/config';
import store from '../store';
import ModalChangeChip from '../components/ModalChangeChip.vue';
import Alert from '../components/Alert.vue';
import Encryption from '../utils/encryption';

export default {
	name: 'Welcome',
	components: {
		HeaderComponent,
		ModalChangeChip,
		Alert,
	},
	data() {
		return {
			title: '',
			description: '',
			titleProgress: '',
			steps: [],
			infoModal: false,
			alertError: false,
		};
	},
	async created() {
		this.$store.dispatch("disableBack", false)
		if (process.env.NODE_ENV === 'development') {
			await this.callInit();
		}

		await Config.getConfig().then((response) => {
			const encryption = new Encryption();
			const decryptedConfig = JSON.parse(encryption.decrypt(response.data ? response.data : response));

			this.$store.dispatch('config', decryptedConfig);
		});
		this.authenticate();
		const config = this.config.welcome;
		this.title = this.isExOi() ? config.title_ExOi : config.title;
		this.description =
			this.isExOi()
				? config['title_description_ExOi']
				: config['title_description'];
		this.titleProgress =
			this.isExOi()
				? config.title_progress_ExOi
				: config['title_progress'];
		this.steps = this.getSteps();
		this.sendTracker('trocar_chip_facil_rapido_seguro', 3, 2);

		this.$store.dispatch('reason', this.config['change-reason-tech-change']);
		
		this.sendCustomDimension('MSISDN_TC', this.customer.login);
		
		this.sendCustomDimension('E-mail_TC', this.customer.email);
		
		this.sendCustomDimension('Segmento_TC', this.customer.segment);
		
		this.sendCustomDimension('Browser_TC', navigator.userAgent);
		if (
			!this.cookieIsDefined('metadata') &&
			!this.cookieIsDefined('access_key')
		) {
			window.location.href = '/';
		}
	},
	computed: {
		...mapState({
			authState: (state) => state.authState,
			authErrorCode: (state) => state.authErrorCode,
			ac: (state) => state.ac,
			config: (state) => state.config,
			customer: (state) => state.customer,
			accessKey: (state) => state.accessKey,
			metadataCookie: (state) => state.metadataCookie,
			eligibilityErrorsCount: (state) => state.eligibilityErrorsCount,
			disableBack: (state) => state.disableBack
		}),
		logoMobile: function () {
			return window.innerWidth < 768;
		},
	},
	methods: {
		getSteps() {
			if (this.config.welcome) {
				if (this.customer.isExOiCustomer) {
					let stepsConfig = this.config.welcome.steps;
					let steps = [];

					for (const step of stepsConfig) {
						if (step.active_flag) steps.push(step);
					}
					return steps;
				} else return this.config.welcome.stepsExOi;
			}
		},
		async callInit() {
			Init.start()
				.then(async (response) => {
					return this.setMetadataAndAccessKey(response);
				})
				.catch(async (error) => {
					return this.setMetadataAndAccessKey(error.response);
				});
		},
		async setMetadataAndAccessKey(response) {
			await Cookies.set(
				'metadata',
				typeof response.headers.metadata.value !== 'undefined'
					? response.headers.metadata.value
					: response.headers.metadata
			);
			await Cookies.set(
				'access_key',
				typeof response.headers['access_key'] !== 'undefined'
					? response.headers['access_key'].value
					: ''
			);
			await Auth.init();
			return;
		},
		async authenticate() {
			Auth.init();
			this.verifyUserEligibity();
		},
		async sendCustomDimension(dimension, value) {
			// Convert value to string if it's not already
			const strValue = String(value);

			// Replace spaces, asterisks, and parentheses
			const sanitizedValue = strValue
				.replace(/\s/g, '_')    // Replace spaces with underscores
				.replace(/\*/g, '_')     // Remove asterisks
				.replace(/[()]/g, '_');  // Remove parentheses - no need to escape inside []
			console.log("Sending " + dimension + ": " + sanitizedValue);
			const command = `decibelInsight("sendCustomDimension", "${dimension}", "${sanitizedValue}");`;
console.log(command)
			window.eval(command);
		},
		async verifyUserEligibity() {
			if (this.customer.COD_ERRO) {
				if (
					store.getters.getAuthErrorCode ==
					this.config.internal_code_for_corporate_client
				) {
					this.$router.push({ name: 'corporate-client-block' });
					return;
				}
				this.$store.dispatch(
					'eligibilityErrorsCount',
					this.eligibilityErrorsCount + 1
				);
				if (this.customer.allowRetries) {
					this.redirectToAnotherAtempt();
				} else {
					this.$router.push({ name: 'call-center' });
				}
			}
			if (this.isExOi()) {
				this.$router.push({ name: 'welcome-exoi' });
			}
		},
		redirectToAnotherAtempt() {
			this.$router.push({
				name: 'default-error',
				params: {
					title: 'Ocorreu um erro, não identificamos seus dados',
					description: 'Por favor tente novamente.',
					actionLabel: 'Voltar',
					action: async () => {
						await Init.start();
						this.trackEligibility();
						this.$router.push({ name: 'welcome' });
					},
				},
			});
		},
		async trackEligibility() {
			await trackEvent.track({
				user: {
					login: this.customer.login,
					loginType: '',
					lineType: this.customer.loginType,
					segment: this.customer.segment,
					subSegment: this.customer.subSegment,
					planCode: this.customer.planCode,
					planName: this.customer.planName,
				},
				channel: trackEvent.getChannel(),
				'event-category': 6,
				'event-action': 2,
				'event-label': `Troca de Chip Erro Ex Oi Elegibilidade Tentativa ${this.eligibilityErrorsCount}`,
				'event-value': null,
				'event-status': 'Sucesso',
				'event-interactionNumber': '',
				'event-error': '',
				'event-errorDetail': '',
			});
		},
		handleClick(key) {
			if (this.steps[key]) {
				this.$store.dispatch(
					'flowEsim',
					this.config.welcome.eligibleNewFlow.includes(
						this.steps[key].action_triggered
					)
				);
				this.sendTracker('trocar_chip_facil_rapido_seguro', 2, 1, this.steps[key].text.toLowerCase());
				this.$router.push({ name: this.steps[key].action_triggered });
			}
		},
		async next() {
			await trackEvent.track({
				user: {
					login: this.customer.login,
					loginType: '',
					lineType: this.customer.loginType,
					segment: this.customer.segment,
					subSegment: this.customer.subSegment,
					planCode: this.customer.planCode,
					planName: this.customer.planName,
				},
				channel: trackEvent.getChannel(),
				'event-category': 6,
				'event-label': 'Troca de Chip Home',
				'event-value': null,
				'event-status': 'Sucesso',
				'event-interactionNumber': '',
				'event-error': '',
				'event-errorDetail': '',
			});
			this.setInitFLow();
		},
		setInitFLow() {
			if (this.isExOi()) {
				this.$store.dispatch('reason', this.config['change-reason-exOi']);
				this.$router.push('/documentos');
				return;
			}
			if (!this.config['init_flow']) return this.documents();
			if (this.config['init_flow']) return this.reasons();
			else this.documents();
		},
		documents() {
			this.$store.dispatch('reason', this.config['change-reason-tech-change']);
			this.$router.push('/InstallationGuide');
		},
		reasons() {
			return this.config['init_flow']
				? this.$router.push('/motivos')
				: this.documents;
		},
		isExOi() {
			if (this.config['init_flow'] === undefined) {
				this.alertError = true;
			}

			return JSON.parse(this.customer.isExOiCustomer);
		},
		sendTracker(eventLabel, eventAction = 2, hitType = 2, eventValue = this.isExOi() ? 'oi' : 'tim') {
			trackEvent.track({
				user: {
					login: this.customer.login,
					loginType: '',
					lineType: this.customer.loginType,
					segment: this.customer.segment,
					subSegment: this.customer.subSegment,
					planCode: this.customer.planCode,
					planName: this.customer.planName,
				},
				channel: trackEvent.getChannel(),
				'event-category': 7,
				'event-label': eventLabel,
				'event-location': 'troca_chip_instrucao_iphone',
				'event-value': eventValue,
				'event-status': 'Sucesso',
				'event-action': eventAction,
				'hit-type': hitType
			});
		},
		sendTrackerButtonDetails() {
			this.sendTracker('trocar_chip_facil_rapido_seguro', 2, 1, 'saiba_mais_detalhes');
			this.infoModal = true;
		},
		cookieIsDefined(nameCookie) {
			var cookies = document.cookie;
			var cookiesArray = cookies.split('; ');
			for (var i = 0; i < cookiesArray.length; i++) {
				var cookie = cookiesArray[i].split('=');
				var nome = cookie[0].trim();
				if (nome === nameCookie) {
					return true;
				}
			}
			return false;
		},
	},
};
</script>
<style lang="scss" scoped>
#welcome_container {
	padding-bottom: 32px;
}

.welcome {
	width: 100%;
	min-height: 100vh;
	position: absolute;
	display: block;
	z-index: -1000;

	.welcome_background {
		width: 100%;
		height: 497px;
		display: block;
		position: absolute;
		top: 0;
		left: 0;
		z-index: -1;

		>img {
			width: 100%;
			height: 100%;
			display: block;
			position: relative;
		}
	}

	.welcome_title {
		width: 100%;
		height: auto;
		margin-top: 80px;
		display: block;
		font-family: 'timsans_bold';
		font-size: 2em;
		font-weight: bold;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.25;
		letter-spacing: -0.04px;
		text-align: center;
		color: #ffffff;
	}

	.welcome_description {
		width: 252px;
		min-height: 48px;
		margin: 16px auto 0 auto;
		display: block;
		position: relative;

		>p {
			width: 252px;
			height: 48px;
			font-family: 'timsans_regular';
			font-size: 0.75em;
			font-weight: normal;
			font-stretch: normal;
			font-style: normal;
			line-height: 1.33;
			letter-spacing: normal;
			text-align: center;
			color: #ffffff;
		}
	}

	.welcome_card {
		width: 100%;
		margin: 32px 0 39px 0;
		border-radius: 30px;
		box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
		background-color: #ffffff;
		display: block;
		box-sizing: border-box;

		>h4 {
			width: 324px;
			min-height: 10px;
			display: block;
			position: relative;
			margin: 0 auto;
			padding-top: 32px;
			font-family: 'timsans_regular';
			font-size: 0.75em;
			font-weight: normal;
			font-stretch: normal;
			font-style: normal;
			text-transform: uppercase;
			line-height: 2;
			letter-spacing: normal;
			text-align: center;
			color: #003091;
		}

		strong {
			width: 324px;
			min-height: 10px;
			display: block;
			position: relative;
			margin: 0 auto;
			padding-top: 32px;
			font-family: 'timsans_regular';
			font-size: 0.8em;
			font-weight: normal;
			font-stretch: normal;
			font-style: normal;
			text-transform: uppercase;
			line-height: 2;
			letter-spacing: normal;
			text-align: center;
			color: #003091;
		}

		>.welcome_list {
			width: 324px;
			height: auto;
			display: block;
			position: relative;
			margin: 0 auto;
			box-sizing: border-box;
			padding: 0 35px;

			>li+li {
				border-top: solid 1px #b2b2b2;
			}

			>li {
				width: 100%;
				list-style: none;

				>div {
					padding: 31px 0;

					>.welcome_number_circle {
						width: 40px;
						height: 40px;
						font-family: 'timsans_bold';
						border-radius: 40px;
						border: solid 2px #003091;
						color: #003091;
						display: grid;
						align-items: center;
						text-align: center;
						font-weight: bold;
					}

					>.welcome_action {
						width: 258px;
						min-height: 20px;
						margin-top: 17px;
						position: relative;
						display: block;
						font-family: 'timsans_bold';
						font-size: 0.85em;
						font-weight: bold;
						font-stretch: normal;
						font-style: normal;
						line-height: 1.71;
						letter-spacing: normal;
						color: #003091;
					}

					>.welcome_list_description {
						width: 100%;
						height: auto;
						font-family: 'timsans_bold';
						font-size: 1.25em;
						font-weight: bold;
						font-stretch: normal;
						font-style: normal;
						line-height: 1.2;
						letter-spacing: normal;
						color: #000000;
						box-sizing: border-box;
					}

					>.welcome_list_link {
						width: 100%;
						height: auto;
						margin-top: 24px;
						font-family: 'timsans_regular';
						font-size: 0.875em;
						text-decoration: underline;
						text-align: center;
						font-stretch: normal;
						font-style: normal;
						line-height: 1.08;
						letter-spacing: normal;
						color: #003091;
					}
				}
			}
		}

		>.welcome_container-btn {
			width: 100%;
			height: auto;
			position: relative;
			display: block;
			padding-bottom: 64px;
		}
	}
}

.button_request {
	margin: 0 auto;
	display: block;
	font-family: 'timsans_regular';
	font-size: 1em;
	text-align: center;
	color: #ffffff;
	border: 0;
	border-radius: 26px;
	width: 251px;
	height: 52px;
	border-radius: 26px;
	background-color: #003091;
	font-family: 'timsans_regular';
}

.primary_button_request {
	border: 1px solid #003091;
	background: #ffffff;
	color: #003091;
}

@media (min-width: 768px) {
	.welcome {
		width: 100%;
		position: absolute;
		display: block;
		z-index: -1000;

		.welcome_background {
			width: 100%;
			height: 497px;
			display: block;
			position: absolute;
			top: 0;
			left: 0;
			z-index: -1;

			>img {
				width: 100%;
				height: 100%;
				display: block;
				position: relative;
			}
		}

		.welcome_title {
			width: 90%;
			margin: 120px auto 0 auto;
			display: block;
			font-family: 'timsans_bold';
			font-size: 3.2em;
			font-style: normal;
			line-height: 1.14;
			letter-spacing: -0.07px;
		}

		.welcome_description {
			width: 585px;
			min-height: 48px;
			margin: 40px auto 0 auto;
			display: block;
			position: relative;

			>p {
				width: 585px;
				height: 48px;
				font-family: 'timsans_regular';
				font-size: 1.5em;
				font-weight: normal;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.33;
				letter-spacing: normal;
				text-align: center;
				color: #ffffff;
			}
		}

		.welcome_card {
			width: 100%;
			min-height: 250px;
			margin: 48px 0 39px 0;
			border-radius: 30px;
			box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
			background-color: #ffffff;
			display: block;
			box-sizing: border-box;

			>h4 {
				width: 647px;
				display: block;
				margin: 0 auto;
				padding-top: 40px;
				font-family: 'timsans_regular';
				font-size: 1.25em;
				color: #003091;
			}

			>.welcome_list {
				width: 100%;
				height: auto;
				display: flex;
				align-items: flex-start;
				position: relative;
				margin: 0 auto;
				box-sizing: border-box;
				padding: 35px;

				>li+li {
					border-top: 0;
					border-left: solid 1px #b2b2b2;
				}

				>li {
					width: 100%;
					display: flex;
					flex-wrap: wrap;
					box-sizing: border-box;

					>div {
						padding: 0 15px;

						>.welcome_number_circle {
							width: 20px;
							height: 20px;
							font-family: 'timsans_bold';
							border-radius: 20px;
							border: solid 2px #003091;
							color: #003091;
							display: grid;
							align-items: center;
							text-align: center;
							font-weight: bold;
							font-size: 0.75em;
						}

						>.welcome_action {
							width: calc(100% - 50px);
							min-height: 40px;
							margin-top: 0px;
							padding-left: 16px;
							font-family: 'timsans_bold';
							font-size: 0.75em;
							line-height: 1.71;
						}

						>.welcome_list_description {
							width: 100%;
							min-height: 100px;
							font-family: 'timsans_bold';
							padding-left: 36px;
							margin-top: 0;
							font-size: 1em;
							line-height: 1.17;
							box-sizing: border-box;
						}
					}
				}
			}

			>.welcome_container-btn {
				width: 320px;
				height: 52px;
				margin: 0 auto;
				position: relative;
				display: block;
				padding-bottom: 64px;
				font-size: 1em;
			}
		}
	}
}

@media (min-width: 960px) {
	.welcome {
		width: 100%;
		position: absolute;
		display: block;
		z-index: -1000;

		.welcome_background {
			width: 100%;
			height: 497px;
			display: block;
			position: absolute;
			top: 0;
			left: 0;
			z-index: -1;

			>img {
				width: 100%;
				height: 100%;
				display: block;
				position: relative;
			}
		}

		.welcome_title {
			width: 748px;
			margin: 120px auto 0 auto;
			display: block;
			font-family: 'timsans_bold';
			font-size: 3.5em;
			font-style: normal;
			line-height: 1.14;
			letter-spacing: -0.07px;
		}

		.welcome_description {
			width: 585px;
			min-height: 48px;
			margin: 40px auto 0 auto;
			display: block;
			position: relative;

			>p {
				width: 585px;
				height: 48px;
				font-family: 'timsans_regular';
				font-size: 1.5em;
				font-weight: normal;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.33;
				letter-spacing: normal;
				text-align: center;
				color: #ffffff;
			}
		}

		.welcome_card {
			width: 100%;
			min-height: 250px;
			margin: 48px 0 39px 0;
			border-radius: 30px;
			box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
			background-color: #ffffff;
			display: block;
			box-sizing: border-box;

			>h4 {
				width: 647px;
				display: block;
				margin: 0 auto;
				padding-top: 40px;
				font-family: 'timsans_regular';
				font-size: 1.25em;
				color: #003091;
			}

			>.welcome_list {
				width: 100%;
				height: auto;
				display: flex;
				align-items: flex-start;
				position: relative;
				margin: 0 auto;
				box-sizing: border-box;
				padding: 35px;

				>li+li {
					border-top: 0;
					border-left: solid 1px #b2b2b2;
				}

				>li {
					width: 100%;
					display: flex;
					flex-wrap: wrap;
					box-sizing: border-box;

					>div {
						padding: 0 31px;

						>.welcome_number_circle {
							border: solid 2px #003091;
							color: #003091;
							font-family: 'timsans_bold';
							font-size: 1em;
							display: grid;
						}

						>.welcome_action {
							width: calc(100% - 60px);
							min-height: 40px;
							margin-top: 12px;
							padding-left: 16px;
							font-family: 'timsans_bold';
							font-size: 1em;
							line-height: 1.71;
						}

						>.welcome_list_description {
							width: 100%;
							min-height: 100px;
							font-family: 'timsans_bold';
							padding-left: 56px;
							margin-top: 0;
							font-size: 1.5em;
							line-height: 1.17;
							box-sizing: border-box;
						}
					}
				}
			}

			>.welcome_container-btn {
				width: 320px;
				height: 52px;
				margin: 0 auto;
				position: relative;
				display: block;
				padding-bottom: 64px;
				font-size: 1em;
			}
		}
	}
}
</style>